import ActionStatus from 'enums/ActionStatus';
import React from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const Flow = ({
  toSteps,
  setStatus,
  notShow,
  disabled,
  currentStatus,
  setMessageAlert,
}) => {
  const { t } = useTranslation();

  if (toSteps.length === 0) return <></>;
  
  const showNameAndMessageStep = (toStep) => {
    let alert = t(`alerts:${toStep.name}`)
    if (currentStatus == ActionStatus.WaitingCancellationApproval) {
      if (toStep.id == ActionStatus.Cancelled) {
        return { label: t('flow:approve_cancellation'), alert: t(`alerts:${toStep.name}`) };
      }
      

      if ([6,9,21,22].includes(toStep.id)) {
        alert = "Solicitação de Cancelamento enviada";
      }
    }

    return { label: t(`flow:${toStep.name}`), alert };
  }

  return (
    <>
      {toSteps.map((toStep, k) => {
        if (!!notShow && !!notShow[toStep.id]) return null;
        return (
          <Button
            size="md"
            variant="primary-login"
            key={k}
            type="submit"
            className="login-btn mr-2 mt-5"
            disabled={(currentStatus == ActionStatus.AwaitingArts && toStep.id == ActionStatus.Cancelled) ? false : disabled}
            onClick={() => {
              setStatus(toStep.id);
              setMessageAlert(showNameAndMessageStep(toStep).alert);
            }}
          >
            {showNameAndMessageStep(toStep).label}
          </Button>
        );
      })}
    </>
  );
};

export default Flow;
